import axios from "api/axios";

export async function getDashboardData() {
  const { data } = await axios.get("/admin/dashboard");
  return (
    data?.data ?? {
      hero: {
        eyebrow: "Operational Overview",
        title: "Payroll operations at a glance",
        subtitle:
          "Track payroll status, approvals, compliance, and key workforce metrics from a single workspace.",
        chips: [],
      },
      stats: [],
      alerts: [],
      quick_links: [],
    }
  );
}
